var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.4 1.2h12.05c.42 0 .82.17 1.12.47l6.76 6.76c.3.3.47.7.47 1.12V18.4c0 .88-.72 1.6-1.6 1.6H2.4c-.88 0-1.6-.72-1.6-1.6V2.8c0-.88.72-1.6 1.6-1.6zm3.05 4.55a1.45 1.45 0 1 0 0-2.9 1.45 1.45 0 0 0 0 2.9zM6.7 9.15h8.4v1.7H6.7v-1.7zm0 3.35h6.1v1.7H6.7v-1.7z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrices);
export default __webpack_public_path__ + "static/media/prices.69b8ef5771fca2807e7adf8e0edcec00.svg";
export { ForwardRef as ReactComponent };